<template>
    <div
        v-if="json"
        id="header-container"
        :class="[...headerClasses, { mouseover: mouseOver }]"
    >
        <header :class="[(mobileNavOpen) ? 'is-active' : 'is-inactive']">
            <div class="capper">
                <div class="capper-padded">
                    <div class="flex-content">
                        <div class="l">
                            <div class="ttmotif">
                                <router-link to="/" aria-label="Home">
                                    <div class="svg-holder">
                                        <TtIcon class="tt" aria-label="Insomniac" />
                                    </div>
                                </router-link>
                            </div>
                        </div>
                        <div class="r rfun" :class="{ 'visible': scrollDirection !== 'top' }">
                            <div class="header-nav-outer">
                                <nav class="header-nav">
                                    <div class="header-nav2">
                                        <router-link class="asvg" to="/" aria-label="Home">
                                            <div class="svg-holder">
                                                <TtIcon class="tt" aria-label="Insomniac" />
                                            </div>
                                        </router-link>
                                        <button aria-label="Menu" :class="['hamburger hamburger--spin']" type="button">
                                            <span class="hamburger-box"><span class="hamburger-inner"></span></span>
                                        </button>
                                        <div class="vertical-line"></div>
                                        <ul>
                                            <li
                                                v-for="(item, index) in json.header.nav"
                                                :key="`header-nav-${index}`"
                                            >
                                                <Link
                                                    :href="item.link"
                                                    :target="item.target"
                                                    :label="item.label"
                                                    :class="['alink', { active: isActive(item.link) }]"
                                                />
                                            </li>
                                        </ul>
                                    </div>
                                </nav>
                            </div>
                        </div>
                        <div class="r rtop">
                            <div class="header-nav-outer header-nav-outer">
                                <nav class="header-nav">
                                    <div class="header-nav2">
                                        <router-link class="asvg" to="/" aria-label="Home">
                                            <div class="svg-holder">
                                                <TtIcon class="tt" aria-label="Insomniac" />
                                            </div>
                                        </router-link>
                                        <button aria-label="Menu" :class="['hamburger hamburger--spin']" type="button">
                                            <span class="hamburger-box"><span class="hamburger-inner"></span></span>
                                        </button>
                                        <div class="vertical-line"></div>
                                        <ul>
                                            <li
                                                v-for="(item, index) in json.header.nav"
                                                :key="`header-nav-${index}`"
                                            >
                                                <Link
                                                    :href="item.link"
                                                    :target="item.target"
                                                    :label="item.label"
                                                    :class="['alink', { active: isActive(item.link) }]"
                                                />
                                            </li>
                                        </ul>
                                    </div>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <div id="mobile-nav-close-hook" v-show="mobileNavOpen" @click="hamburgerClose"></div>
        <div id="mobile-nav-hamburger" :class="[(mobileNavOpen) ? 'is-active' : 'is-inactive']">
            <div class="newfun">
                <router-link class="asvg" to="/" aria-label="Home">
                    <div class="svg-holder">
                        <TtmotifIcon class="tt" aria-label="Insomniac"/>
                    </div>
                </router-link>
                <div class="vertical-line"></div>
                <button aria-label="Menu" @click="hamburgerToggle" :class="['hamburger hamburger--spin']" type="button">
                    <span class="hamburger-box"><span class="hamburger-inner"></span></span>
                </button>

            </div>
            <!--
            <button :class="['hamburger hamburger--spin', (mobileNavOpen) ? 'is-active' : '']" @click="hamburgerToggle"
                    type="button">
                <span class="hamburger-box"><span class="hamburger-inner"></span></span>
            </button>
            -->
        </div>
        <div id="mobile-nav-overlay-outer" :class="[(mobileNavOpen) ? 'is-active' : 'is-inactive']">
            <button aria-label="Menu" :class="['hamburger hamburger--spin', (mobileNavOpen) ? 'is-active' : '']" @click="hamburgerToggle"
                    type="button">
                <span class="hamburger-box"><span class="hamburger-inner"></span></span>
            </button>
            <router-link to="/" aria-label="Home">
                <TtIcon class="tt" aria-label="Insomniac" />
            </router-link>
            <nav class="mobile-nav">
                <ul>
                    <li
                        v-for="(item, index) in json.header.nav"
                        :key="`header-nav2-${index}`"
                        @click="hamburgerClose"
                    >
                        <Link
                            :href="item.link"
                            :target="item.target"
                            :label="item.label"
                            :class="['alink', { active: isActive(item.link) }]"
                        />
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import Link from "@/components/pieces/Link";
import TtIcon from "@/components/svgs/Tt.vue";
import TtmotifIcon from "@/components/svgs/Ttmotif.vue";
export default {
    name: "HeaderComponent",
    components: {TtIcon, TtmotifIcon, Link},
    data() {
        return {
            json: null,
            previousScrollY: 0,
            scrollDirection: 'top',
            scrollY: 0, // reactive scroll position
            mouseOver: false, // track mouse state over the header-container
        }
    },
    watch: {

    },
    computed: {
        ...mapState({
            smallHeader: state => state.smallHeader,
            mobileNavOpen: state => state.mobileNavOpen,
        }),
        headerClasses() {
            const classes = [`route-type-${this.$route.meta.type || 'default'}`];
            if (this.smallHeader) {
                classes.push('small');
            }
            if (this.scrollY === 0) {
                classes.push('top');
            } else {
                classes.push(this.scrollDirection);
            }
            return classes;
        }
    },
    mounted() {
        this.json = window.config.json.global;
        this.previousScrollY = window.scrollY;
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('wheel', this.handleWheel);

        // nav width related
        window.addEventListener('resize', this.updateNavWidth);
        this.updateNavWidth();
        setTimeout(this.updateNavWidth, 100)
        setTimeout(this.updateNavWidth, 500)
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('wheel', this.handleWheel);
        window.removeEventListener('resize', this.updateNavWidth);
    },
    methods: {
        updateNavWidth() {
            this.$nextTick(() => {
                const navElements = this.$el.querySelectorAll('.header-nav2');
                let maxWidth = 0;

                navElements.forEach(nav => {
                    if (nav.offsetWidth > maxWidth) {
                        maxWidth = nav.offsetWidth;
                    }
                });

                if (maxWidth > 0) {
                    maxWidth += 40 // extra margins
                    document.documentElement.style.setProperty('--header-nav-width', `${maxWidth}px`);
                }
            });
        },
        isActive(link) {
            return link === this.$route.path;
        },
        handleScroll() {
            const currentScrollY = window.scrollY;
            this.scrollY = currentScrollY; // update reactive scrollY

            if (currentScrollY === 0) {
                this.scrollDirection = 'top';
            } else if (currentScrollY > this.previousScrollY) {
                this.scrollDirection = 'scrolling-down';
            } else if (currentScrollY < this.previousScrollY) {
                this.scrollDirection = 'scrolling-up';
            }
            this.previousScrollY = currentScrollY;
        },
        handleWheel(e) {
            // Update scroll direction based on the wheel event delta
            if (e.deltaY < 0) {
                this.scrollDirection = 'scrolling-up';
            } else if (e.deltaY > 0) {
                this.scrollDirection = 'scrolling-down';
            }
        },
        hamburgerClose() {
            this.$store.commit("setMobileNavOpen", false);
        },
        hamburgerOpen() {
            this.$store.commit("setMobileNavOpen", true);
        },
        hamburgerToggle() {
            if (this.mobileNavOpen) {
                this.hamburgerClose()
            } else {
                this.hamburgerOpen()
            }
        },

    }
}
</script>
